import AlertTriangleIcon from '@crehana/compass.icons.outline/AlertTriangle';
import RefreshIcon from '@crehana/compass.icons.outline/Refresh';
import { Button } from '@crehana/compass.ui/button';
import { cn } from '@crehana/compass.ui/utils';

import { useHomeTranslations } from '@/views/Home/hooks/use-home-translations';

type TErrorLoadingWidgetsProps = React.HTMLAttributes<HTMLDivElement> & {
  onRetry: () => void;
};

export const ErrorLoadingWidgets: React.FC<TErrorLoadingWidgetsProps> = ({
  onRetry,
  className,
}) => {
  const { t } = useHomeTranslations();

  return (
    <div
      className={cn(
        'tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-text-center tw-bg-neutral-light-100',
        // Padding
        'tw-px-3.2 md:tw-px-11.2 tw-py-9.6 md:tw-py-12.4',
        // Rounded
        'tw-rounded-1.6',
        // Border
        'tw-border-0.1 tw-border-solid tw-border-neutral-light-400',
        className,
      )}
    >
      <div className="tw-text-alert-500 tw-bg-alert-200 tw-rounded-full tw-p-1.2 tw-border-0.8 tw-border-solid tw-border-alert-100 tw-mb-1.2">
        <AlertTriangleIcon className="tw-fill-current tw-flex-none" size={28} />
      </div>
      <h2 className="tw-font-subtitle4 tw-font-medium tw-mb-0.8">
        {t('ERROR_WIDGET_TITLE')}
      </h2>
      <p className="tw-font-body4 tw-mb-1.2">{t('ERROR_WIDGET_MESSAGE')}</p>
      <Button type="button" onClick={onRetry} variant="primary">
        <RefreshIcon
          className="tw-fill-current tw-flex-none tw-text-neutral-light-100"
          size={16}
        />
        {t('ERROR_WIDGET_RETRY_BUTTON')}
      </Button>
    </div>
  );
};
